export default "__VITE_ASSET__CPRJihc___"